import UniBadge from "../university/uniBadge";
import "../../styles/additional.css";

export default function UniversitiesSlider({ UNIS, bigMargin = false, needMargin= true }: {UNIS: any, bigMargin?: boolean, needMargin?: boolean}) {

    let cName= "flex flex-col items-center space-y-4 justify-center mx-auto text-center";
    if (needMargin){
        cName+= bigMargin ? " my-[1rem] lg:mt-[20rem] mt-[35rem] w-5/6" : " my-[1rem] lg:mt-[100px] mt-[6rem] w-5/6 small-margin";
    }
    return (
        <>
            <div className={cName}>
                <div className="font-semibold text-h2 text-primary-blue">Pourquoi choisir nos talents ?</div>
                <div className="text-[#6F6F6F] font-normal md:text-[22px] md:leading-[28.64px] text-[18px] font-dm-sans">Nos freelances proviennent d'institutions de premier plan, apportant avec eux un savoir-faire exceptionnel.</div>
            </div>
            <div className={bigMargin ? "w-full no-transparent-slides overflow-hidden mb-[100px]" : "w-full no-transparent-slides overflow-hidden"} id="universities-slider">
                <div className="w-[95%] mx-auto no-clip-slider py-[20px]" >
                    <SimpleButCoolSlider UNIS={UNIS}/>
                </div>
            </div>
        </>
    );
};

const SimpleButCoolSlider= ({UNIS}: any) => {//<-plain slider madewith just css. Simple but does the job.
    return(<>
        <div className="w-full py-[20px]">
            <div className="s-track">
                {
                    UNIS.map((uni: any, index: number) => (<>
                            <UniBadge
                                key={"copy-" + index}
                                name={uni.name}
                                emblem={"/Universities/universityLogos/" + uni.image_name}
                                country={uni.country}
                            />
                    </>))
                }
                {
                    UNIS.map((uni: any, index: number) => (<>
                            <UniBadge
                                key={index}
                                name={uni.name}
                                emblem={"/Universities/universityLogos/" + uni.image_name}
                                country={uni.country}
                            />
                    </>))
                }
            </div>
        </div>
    </>);
};